import React, { useContext } from 'react';
import { Accordion, Row } from 'react-bootstrap';
import AccordionContext, { isAccordionItemSelected } from 'react-bootstrap/AccordionContext';
import { useParams } from 'react-router-dom';
import SingleIndicatorDetails from './SingleIndicatorDetails';
import IndicatorTagBadge from './IndicatorTagBadge';
import { GoalsContext } from '../State/GoalsContext';

/**
 * Mount indicator details only while the accordion item is open.
 * Collapsed panels stay display:none; mounting Chart.js there makes bars/lines
 * animate from the top-left on first expand.
 */
const AccordionIndicatorBody = ({ eventKey, indicator }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const isOpen = isAccordionItemSelected(activeEventKey, eventKey);
  if (!isOpen) return null;
  return <SingleIndicatorDetails indicator={indicator} embeddedInAccordion />;
};

const IndicatorsAccordion = ({ indicators }) => {
  const { indicatorId } = useParams();
  const { goalType } = useContext(GoalsContext);
  const isUN = goalType === 'un';

  return (
    <Row className="indicators-accordion-group">    
       {/*Display section title if any items available  */}
      { indicators.length > 0  && (
        <div className='section-title'>
          <h6 className="sdg-section-title">Indicators</h6>
        </div>
      )}
      <Accordion defaultActiveKey={indicatorId ? indicatorId.toString() : '0'}>
        {indicators.map(indicator => {
          const eventKey = indicator.id.toString();
          return (
          <div key={indicator.id} className='accordion-item-container'>
            <Accordion.Item eventKey={eventKey}>
              <Accordion.Header>
                <p>
                  <strong>{indicator.acf.index}</strong>
                  {' - '}
                  <span>{indicator.title || indicator.title_render?.replace(/^\d+(?:\.[0-9a-z]+)*\s*[·-]\s*/i, '') || ''}</span>
                  {!isUN && (
                    <IndicatorTagBadge tag={indicator.indicatorTag || indicator.indicator_tag} />
                  )}
                </p>
              </Accordion.Header>
              <Accordion.Body>
                {/* embeddedInAccordion: hide duplicate title + nested card border;
                    standalone AllGoalIndicators views omit this prop. */}
                <AccordionIndicatorBody eventKey={eventKey} indicator={indicator} />
              </Accordion.Body>
            </Accordion.Item>
          </div>
          );
        })}
      </Accordion>
    </Row>
  );
};

export default IndicatorsAccordion;
